export enum CarPaneType {
    ADD = 'ADD',
    EDIT = 'EDIT',
}